import { Tooltip } from "antd";
import OffsetIcon from "components/svg-icons/offset-icon";
import { DATE_FORMAT_MMDDYYYY, DateUtils } from "utils/dateutils";

function ActivityOffsetTag(props: { task: any; isShowDate?: boolean }) {
  const { task, isShowDate } = props;
  const duration =
    task?.offset_duration < 0
      ? `${task?.offset_duration || ""}`
      : `+${task?.offset_duration || ""}`;

  return (
    <Tooltip title={`Activity Offset by ${duration || ""} days.`}>
      <div className="flex flex-shrink items-center justify-center font-normal text-[10px] px-[2px] bg-ciq-gray-250 rounded-sm">
        <span className="flex items-center">
          <OffsetIcon />
        </span>
        {isShowDate ? (
          <span className="text-black opacity-90">
            {DateUtils.format(task?.linked_offset_date, DATE_FORMAT_MMDDYYYY)}
          </span>
        ) : (
          <span className="text-black opacity-88">{duration}</span>
        )}
      </div>
    </Tooltip>
  );
}
export default ActivityOffsetTag;
